import React from "react";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
import Button from "./Button";
import Progress from "./Progress";

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  onSave,
  onCancel,
  saveText = "Salvar",
  cancelText = "Cancelar",
  saveDisabled = false,
  showActions = true,
  maxWidth = "max-w-lg",
  maxBodyHeight = "max-h-[70vh]",
  bodyClassName = "",
  progress,
  progressLabel,
}) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end bg-black/45 p-2 sm:items-center sm:justify-center sm:p-4"
      onClick={handleBackdropClick}
    >
      <section
        className={cn(
          "w-full rounded-t-2xl border border-border bg-card text-card-foreground shadow-xl sm:rounded-2xl",
          maxWidth
        )}
      >
        <header className="flex items-center justify-between border-b border-border px-4 py-3 sm:px-6">
          <h2 className="font-display text-base font-semibold sm:text-lg">{title}</h2>
          <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8">
            <X className="h-4 w-4" />
          </Button>
        </header>

        <div className={cn(maxBodyHeight, "overflow-y-auto p-4 sm:p-6", bodyClassName)}>
          {typeof progress === "number" ? (
            <div className="mb-4 space-y-1.5">
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>{progressLabel || "Progresso do formulário"}</span>
                <span>{Math.round(Math.max(0, Math.min(100, Number(progress) || 0)))}%</span>
              </div>
              <Progress value={progress} />
            </div>
          ) : null}
          {children}
        </div>

        {showActions && (
          <footer className="flex flex-col-reverse gap-2 border-t border-border px-4 py-3 sm:flex-row sm:justify-end sm:px-6">
            <Button variant="outline" onClick={onCancel || onClose} className="w-full sm:w-auto">
              {cancelText}
            </Button>
            <Button onClick={onSave} disabled={saveDisabled} className="w-full sm:w-auto">
              {saveText}
            </Button>
          </footer>
        )}
      </section>
    </div>
  );
}
